module.exports = __webpack_public_path__ + "img/2.b4095d6a.jpg";